// extracted by mini-css-extract-plugin
module.exports = {"centered":"centered--wIU5w","container":"container--a31hH","logo":"logo--7d8qM","title":"title--mE1lj","message":"message--WMxCe","backButton":"backButton--5HDGG"};